import { Dispatch } from 'redux';
import TableInner from '../../../Form/components/Controls/Table/TableInner';
import { Header } from '../../types/types';
import { substituteNodeRefsByLabel } from '../../../../utils/tableAsyncCells';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../../../ModalTest';
import Button from '../../../Button';
import { toggleModal } from '../../../ModalTest/actions';

interface TableModalProps {
  actions: any;
  modal: any;
  header: Header;
  body: { [key: string]: string }[];
  name: string;
  index: number;
}

class TableModal extends (window as any).React.PureComponent<TableModalProps> {
  render() {
    const { actions, header, body, name, index, usedObjects } = this.props;
    return (
      <Modal name={`${name}TableModal${index}`} fullWidth>
        <div className="modal-body">
          <div className="MuiTableContainer-root table-wrap">
            <TableInner {...{
              name,
              value: body,
              wholeTableDislplayValues: substituteNodeRefsByLabel(body, header, usedObjects),
              params: { tableHeaders: header },
              formInstanceId: "",
              view: true, label: ""
            }} />
          </div>
        </div>
        <div className="modal-actions">
          <Button
            label={window.Alfresco.messages.global['button.close']}
            onClick={() => actions.toggleModal(false, `${name}TableModal${index}`)}
          />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state: any) => ({
  modal: state?.modal,
  usedObjects: state?.cacheReducer?.usedObjects || {},
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableModal);
